"use strict";
/*
 * Created on 25. 2. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _get = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/get");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var immutable_1 = require("immutable");

var ResultSeverity_1 = require("../../../core/model/errors/ResultSeverity");

var ValidationResultFlag_1 = require("../../../core/model/errors/ValidationResultFlag");

var ValidationResultObject_1 = require("../../../core/model/errors/ValidationResultObject");

var EntityEventFlag_1 = require("../../../core/model/event/EntityEventFlag");

var FlagSet_1 = require("../../../core/model/FlagSet");

var ObjectUtils_1 = require("../../../core/utils/ObjectUtils");

var ReleaseItemValidationKey_1 = require("../../../release/model/alerts/ReleaseItemValidationKey");

var RequiresRecalculation_1 = require("../../../release/model/alerts/RequiresRecalculation");
/**
 * Product removed from family.
 * @author Radek Beran
 */


var ProductRemovedFromFamily =
/*#__PURE__*/
function (_EntityEventFlag_1$En) {
  _inherits(ProductRemovedFromFamily, _EntityEventFlag_1$En);

  function ProductRemovedFromFamily(familyName) {
    var _this;

    _classCallCheck(this, ProductRemovedFromFamily);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ProductRemovedFromFamily).call(this));
    _this.familyName = familyName;
    return _this;
  }

  _createClass(ProductRemovedFromFamily, [{
    key: "createMessage",
    value: function createMessage() {
      return new ValidationResultObject_1.ValidationResultObject(ResultSeverity_1.ResultSeverity.Warn, ReleaseItemValidationKey_1.ReleaseItemMessageCode.ProductRemovedFromFamily, immutable_1.List.of(this.familyName), null, null, FlagSet_1.FlagSet.of(ValidationResultFlag_1.ValidationResultFlag, RequiresRecalculation_1.RequiresRecalculation.INSTANCE));
    }
  }, {
    key: "validate",
    value: function validate() {
      return true;
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "equals",
    value: function equals(other) {
      if (other instanceof ProductRemovedFromFamily) {
        return _get(_getPrototypeOf(ProductRemovedFromFamily.prototype), "equals", this).call(this, other) && this.familyName === other.familyName;
      } else {
        return false;
      }
    }
    /**
     * @inheritDoc
     */

  }, {
    key: "hashCode",
    value: function hashCode() {
      return ObjectUtils_1.ObjectUtils.hashCode(this.tag + this.familyName);
    }
  }]);

  return ProductRemovedFromFamily;
}(EntityEventFlag_1.EntityEventFlag);

exports.ProductRemovedFromFamily = ProductRemovedFromFamily;
ProductRemovedFromFamily.TAG = EntityEventFlag_1.EntityEventFlag.register(ProductRemovedFromFamily);
ProductRemovedFromFamily.PROTOTYPE = new ProductRemovedFromFamily('');